import { Uuid } from "@/domains/global/identifiers";
import { resolveSyncModelNamespacedUuid } from "@/modules/uuid/sync-models/resolveSyncModelNamespacedUuid";
import { SyncModelKind } from "@/store/sync/types";

export const resolveSpaceAccountChatMessageSyncModelUuid = ({
  spaceAccountId,
  chatMessageId,
}: {
  spaceAccountId: Uuid;
  chatMessageId: Uuid;
}): Uuid => {
  return resolveSyncModelNamespacedUuid({
    modelKind: { value: SyncModelKind.SpaceAccountChatMessage },
    uuids: [spaceAccountId, chatMessageId],
  });
};
